import AuthService from './auth-service';

// 새로고침 직후에도 곧바로 판정할 수 있게 저장된 값으로 초기화한다
const storedMenuEventCds = (() => {
  try {
    const raw = localStorage.getItem('menuEventCds');
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
})();

export const auth = {
  namespaced: true,
  state: {
    status: {},
    user: null,
    // 허가된 메뉴 이벤트 코드. null 이면 아직 로드되지 않은 상태다.
    // 전화번호 마스킹은 이 값이 준비되기 전에는 가린 채로 둔다(fail-closed)
    menuEventCds: storedMenuEventCds,
  },
  actions: {
    login({ commit }, loginInfo) {
      return AuthService.login(loginInfo).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        }
      );
    },
    loginCustomer({ commit }, loginInfo) {
      return AuthService.loginCustomer(loginInfo).then(
        (user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error.response.data);
        }
      );
    },
    logout({ commit }) {
      const refreshToken = auth.state.user
          ? auth.state.user.refreshToken
          : null;
      AuthService.logout(refreshToken);
      commit('logout');
    },

    switchCenter({ commit }, centerId) {
      return AuthService.switchCenter(centerId).then(
          (user) => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          },
          (error) => {
            return Promise.reject(error.response.data);
          }
      );
    },
  },
  getters: {
    isSystemAdmin(state) {
      // 시스템 관리자 여부
      return state.user.tt === 'F';
    },
    isInsteadOfAdmin(state) {
      // 시스템 관리자 여부
      return state.user.insteadAdmin;
    },
    isCareAdmin(state) {
      // 케어 어드민 여부
      return state.user.tt === 'S';
    },
    isCenterAdmin(state) {
      // 센터 어드민 여부
      return state.user.tt === 'C';
    },
    isCenterStaff(state) {
      // 센터 직원 여부
      return state.user.tt === 'D';
    },
    isCustomer(state) {
      // 일반 회원 여부
      return state.user.tt === 'N';
    },
    cId(state) {
      // 로그인한 센터 id
      return state.user ? state.user.cid : null;
    },
    staffId(state) {
      // 로그인한 staff id
      return state.user.uid;
    },
    storeTest(state) {
      return state.user;
    },
    staffEmail(state) {
      return state.user.userId;
    },
    roleName(state) {
      // 권한 이름
      return state.user.rnm;
    },
    userName(state) {
      return state.user.unm;
    },
    centerChains(state) {
      // 체인점 목록 (체인점 최고관리자가 아니면 length == 0)
      return state.user.centerChains;
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
      // 센터 전환도 이 경로로 들어온다. 이전 센터/사용자의 권한으로 판정하면 안 되므로
      // 새 권한을 받을 때까지 닫아 둔다(전화번호는 가려진 채로 시작한다)
      state.menuEventCds = null;
      try {
        localStorage.removeItem('menuEventCds');
      } catch (e) {
        // 저장소를 쓸 수 없으면 store 값만으로 판정한다
      }
    },
    loginFailure(state) {
      state.status = {};
      state.user = null;
    },
    logout(state) {
      state.status = {};
      state.user = null;
      state.centers = [];
      state.menuEventCds = null;
    },
    setMenuEventCds(state, eventCds) {
      state.menuEventCds = Array.isArray(eventCds) ? eventCds : null;
    },
    setCenters(state, centers) {
      state.centers = centers;
    }
  },
};
